import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { RED } from '@/features/theme';
import { useGroupContext } from '../GroupContext';

const StyledError = styled.div(() => {
  return {
    fontSize: '12px',
    lineHeight: '150%',
    fontWeight: 400,
    color: RED,
  };
});

interface IErrorProps extends PropsWithChildren {
  className?: string;
}

export const Error = ({
  className,
  children,
}: IErrorProps) => {
  const { isInvalid } = useGroupContext();

  if (!isInvalid) {
    return null;
  }

  return (
    <StyledError className={className}>
      {children}
    </StyledError>
  );
};
